<script lang="ts">
	import { EnterOnView } from '$lib/actions/animations/EnterOnView';
	import { Thumbnail } from '@atoms';
	import { type ImageData } from '@queries/datoCMS/DatoCMSQueries';

	const {
		items
	}: {
		items: {
			published?: string;
			description: string;
			media: ImageData;
			path: string;
		}[];
	} = $props();
</script>

<div class="content">
	{#each items as item, i}
		<div class="case" use:EnterOnView={{ delay: i * 0.05 }}>
			<Thumbnail {...item}></Thumbnail>
		</div>
	{/each}
</div>

<style lang="scss">
	.content {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
		gap: var(--prop-gap);
	}
</style>
